import styled from 'styled-components';

const Wrapper = styled.div`
	.supported-content {
		margin-bottom: 3rem;

		h1 {
			font-size: 28px;
			font-weight: 600;
		}

		.image-container {
			text-align: center;
			img {
				width: 100%;
			}
		}

		.content-container {
			.title,
			.amount {
				font-size: 24px;
				font-weight: 600;
			}

			.city,
			.date {
				font-size: 21px;
			}
		}
  }

  .amount-component {
    width: 100%;

    @media screen and (min-width: 500px) {
      width: 50%;
    }

    @media screen and (min-width: 1199px) {
      width: 270px;
    }
  }

	.pd-0-50 {
			padding: 10px 20px;
  }
  .ps-sparent-text {
    color: #808080;
    margin-bottom: 20px;
    span {
      color: red
    }
  }
`;

const BranchNewsLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 0;

  cursor: ${(props) => (props.pointer ? 'pointer' : 'wait')};

  &:hover {
    background: #f1f1f1;
  }
`;

const ProjectTitle = styled.h1`
  font-family: Sparkasse-Head;
  font-size: 34px;
  line-height: 1.06;
  padding: 50px 10px 0 10px;
  text-align: center;
  margin: 0;
`;

const ProjectSubTitle = styled.div`
  font-family: Sparkasse-Regular;
  font-size: 13px;
  color: #ff0000;
  padding: 20px 10px 0 10px;
`;

const ProjectOrganizationName = styled.div`
  font-family: Sparkasse-Regular;
  font-size: 14px;
  color: #9e9e9e;
  text-align: center;
  line-height: 1.79;
  padding: 0 10px 0 10px;
`;

const ProjectAmount = styled.div`
  font-family: Sparkasse-Bolder;
  font-size: 21px;
  color: #000000;
  position: relative;
  margin-top: -3px;
`;

const ProjectAmountTitle = styled.div`
  position: relative;
  margin-top: -3px;
`;

export const EGMTextWrap = styled.div`
  position: relative;
`;

const ProjectDivider = styled.div`
  width: 25%;
  height: 1px;
  opacity: 0.5;
  border: solid 1px #979797;
  margin: 20px 0;
`;

const ProjectDescription = styled.div`
  width: 640px;
  font-family: Sparkasse-Regular;
  font-size: 16px;
  line-height: 1.56;
  color: #808080;

  a {
		color: red
	}
`;

// export default Wrapper;
export {
  Wrapper, ProjectTitle, ProjectSubTitle, ProjectOrganizationName, ProjectAmount, ProjectAmountTitle,
  ProjectDivider, ProjectDescription, BranchNewsLoader
};
